export const DIMENSION_TRUNCATE = 25;
